import { Violation, ViolationSeverity } from './../violation';
import { getPropertyRulesFor, updatePropertyRulesFor } from './utils';

export class RangeError extends Violation {
    public constructor(message: string) {
        super(ViolationSeverity.Error, message);
    }
}

export function Range(args: { min?: number; max?: number }, message: string): PropertyDecorator {
    return (target: Object, propertyKey: string | symbol): void => {
        const key = propertyKey as string;
        const propertyRules = getPropertyRulesFor(target, key);

        propertyRules.push([{
            async: false,
            violationType: RangeError.bind(null, message),
            validate: (context, { min = 0, max = Number.MAX_VALUE }) => {
                const value = context.source[key];
                return value >= min && value <= max;
            }
        }, args]);

        updatePropertyRulesFor(target, key, propertyRules);
    };
}
